// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { useContext } from "react";
import * as React from "react";

/* Starter Custom Code */
import { infoProps } from "@store/Themes/common/props/info";
/* Starter Custom Code */

/* Greif Custom Code - Start */
import AlertTriangleFill from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import isEqual from "@store/Framework/Common/Utilities/isEqual";
import Tooltip, { TooltipPresentationProps } from "@store/MobiusOverrides/Tooltip/Tooltip";
/* Greif Custom Code - End */

export interface OrderDetailsDeliveryTermsStyles {
    titleText?: TypographyPresentationProps;
    termsText?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    // Greif Custom Code
    changeTooltipAlert?: TooltipPresentationProps;
}

export const deliveryTermsStyles: OrderDetailsDeliveryTermsStyles = {
    titleText: infoProps.label,
    termsText: infoProps.value,
    /* Greif Custom Code - Start */
    changeTooltipAlert: {
        iconProps: {
            color: "warning",
            src: AlertTriangleFill,
        },
    },
    /* Greif Custom Code - End */
};
const styles = deliveryTermsStyles;

const OrderDetailsDeliveryTerms = () => {
    const { value: order } = useContext(OrderStateContext);

    /* Greif Custom Code - Start */
    const [orderChangePropriety, setOrderChangePropriety] = React.useState<any>();

    React.useEffect(() => {
        if (order?.properties.orderChanges) {
            setOrderChangePropriety(JSON.parse(order?.properties.orderChanges));
        }
    }, [order?.properties.orderChanges]);
    /* Greif Custom Code - End */

    if (!order || !order.properties.deliveryTerms) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography as="h3" {...styles.titleText}>
                {translate("Delivery Terms")}
            </Typography>
            <Typography {...styles.termsText}>
                {order.properties.deliveryTermsDescription}
                {
                    /* Greif Custom Code - Start */
                    orderChangePropriety?.deliveryTerms &&
                        !isEqual(orderChangePropriety?.deliveryTerms, order.properties.deliveryTerms) && (
                            <Tooltip
                                text={translate(
                                    `Delivery Terms has been updated from {0} to {1}`,
                                    orderChangePropriety?.deliveryTerms,
                                    order.properties.deliveryTerms,
                                )}
                                {...styles.changeTooltipAlert}
                            />
                        )
                    /* Greif Custom Code - End */
                }
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsDeliveryTerms,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
